import { request } from '@pb/utils'

import { API_ENDPOINTS } from 'App/constants'

import { PointsOverviewSectionOrders, PointsHistoryResponse } from './duck/types'

export const fetchPointsHistory = async (): Promise<PointsHistoryResponse> => {
  const { data } = await request.get('user/points-history', {
    apiVersion: 2,
  })
  return data
}

export const fetchOrderOfPoints = async (): Promise<PointsOverviewSectionOrders> => {
  const { data } = await request.get(`${API_ENDPOINTS.DCDUrl}/123/me-php-conscious-actions`)
  return data
}
